import axios from 'axios'

export const getFileContent = url => axios.get(url)
